export default __webpack_public_path__ + "94676e89499274366e2e3ec9fdd7bad2.png";